import { CartaoPeriodoPadrao } from '../shared/enums/cartao-periodo-padrao.enum';
import { CreateCard } from './create-card';

export class AddCards {
    public assignorGuid: string;
    public managerGuid: string;
    public assignorContractsId: number[];
    public collaboratorId: number;
    public groupGuid: string;
    public createCards: CreateCard[];
    public productCategoryWallet: number;
    constructor() { }
}

export class AddBatchCards {
    public AddCards: AddCards;
    public collaboratorsId: number[];
    public selectAll: boolean;
    constructor() { }
}
